const STORAGE_KEY = 'contact-agent-tenant-id';

export function getContactAgentTenantId(): string | undefined {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY)?.trim().slice(0, 64);
    return value || undefined;
  } catch {
    return undefined;
  }
}

export function setContactAgentTenantId(tenantId: string): void {
  sessionStorage.setItem(STORAGE_KEY, tenantId.slice(0, 64));
}

export function scopedParams(extra?: Record<string, unknown>): Record<string, unknown> | undefined {
  const tenantId = getContactAgentTenantId();
  if (!tenantId && !extra) {
    return undefined;
  }
  return { ...extra, ...(tenantId ? { tenantId } : {}) };
}

function firstFieldError(payload: unknown): string | null {
  if (!payload || typeof payload !== 'object') {
    return null;
  }
  const fieldErrors = (payload as { fieldErrors?: Record<string, string[]> }).fieldErrors;
  if (!fieldErrors) {
    return null;
  }
  for (const messages of Object.values(fieldErrors)) {
    const message = messages?.[0];
    if (message) {
      return message.slice(0, 300);
    }
  }
  return null;
}

export function contactAgentError(error: unknown): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const response = (error as { response?: { status?: number; data?: { error?: unknown; message?: unknown } } })
      .response;
    if (response?.status === 404) {
      return 'No se encontró';
    }
    const payload = response?.data?.error;
    if (typeof payload === 'string' && payload) {
      return payload.slice(0, 300);
    }
    const fieldMessage = firstFieldError(payload);
    if (fieldMessage) {
      return fieldMessage;
    }
    if (typeof response?.data?.message === 'string' && response.data.message) {
      return response.data.message.slice(0, 300);
    }
  }
  return error instanceof Error ? error.message : 'Error inesperado';
}
